"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Dialog = _interopRequireDefault(require("@instructure/ui-a11y/lib/components/Dialog"));

var _CloseButton = _interopRequireDefault(require("@instructure/ui-buttons/lib/components/CloseButton"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _uiPropTypes = require("@instructure/ui-prop-types");

var _createChainedFunction = _interopRequireDefault(require("@instructure/ui-utils/lib/createChainedFunction"));

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _bidirectional = _interopRequireDefault(require("@instructure/ui-i18n/lib/bidirectional"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _Portal = _interopRequireDefault(require("@instructure/ui-portal/lib/components/Portal"));

var _mirrorPlacement = require("@instructure/ui-layout/lib/utils/mirrorPlacement");

var _Transition = _interopRequireDefault(require("@instructure/ui-motion/lib/components/Transition"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _temp;

var styles = {
  componentId: 'bFgzf',
  template: function template(theme) {
    return "\n\n.bFgzf_bGBk{background-color:".concat(theme.background || 'inherit', ";box-sizing:border-box;max-height:100vh;max-width:100vw;overflow-x:hidden;overflow-y:auto;position:fixed;z-index:").concat(theme.zIndex || 'inherit', "}\n\n.bFgzf_dHtp{border-color:").concat(theme.borderColor || 'inherit', ";border-style:").concat(theme.borderStyle || 'inherit', ";border-width:0}\n\n.bFgzf_fSpQ{box-shadow:").concat(theme.boxShadow || 'inherit', "}\n\n.bFgzf_bgun,.bFgzf_dLYh{inset-inline-end:0;inset-inline-start:0}\n\n[dir=ltr] .bFgzf_bgun,[dir=ltr] .bFgzf_dLYh{left:0;right:0}\n\n[dir=rtl] .bFgzf_bgun,[dir=rtl] .bFgzf_dLYh{left:0;right:0}\n\n.bFgzf_bQpq,.bFgzf_bxia{bottom:0;top:0}\n\n.bFgzf_bQpq.bFgzf_dfBC,.bFgzf_bxia.bFgzf_dfBC{width:").concat(theme.xSmallWidth || 'inherit', "}\n\n.bFgzf_bQpq.bFgzf_doqw,.bFgzf_bxia.bFgzf_doqw{width:").concat(theme.smallWidth || 'inherit', "}\n\n.bFgzf_bQpq.bFgzf_cXTs,.bFgzf_bxia.bFgzf_cXTs{width:").concat(theme.regularWidth || 'inherit', "}\n\n.bFgzf_bQpq.bFgzf_ycrn,.bFgzf_bxia.bFgzf_ycrn{width:").concat(theme.mediumWidth || 'inherit', "}\n\n.bFgzf_bQpq.bFgzf_cMDj,.bFgzf_bxia.bFgzf_cMDj{width:").concat(theme.largeWidth || 'inherit', "}\n\n.bFgzf_ehJX{bottom:0;left:0;right:0;top:0}\n\n.bFgzf_bxia{inset-inline-end:auto;inset-inline-start:0}\n\n[dir=ltr] .bFgzf_bxia{left:0;right:auto}\n\n[dir=rtl] .bFgzf_bxia{left:auto;right:0}\n\n.bFgzf_bxia.bFgzf_dHtp{border-inline-end-width:").concat(theme.borderWidth || 'inherit', "}\n\n[dir=ltr] .bFgzf_bxia.bFgzf_dHtp{border-right-width:").concat(theme.borderWidth || 'inherit', "}\n\n[dir=rtl] .bFgzf_bxia.bFgzf_dHtp{border-left-width:").concat(theme.borderWidth || 'inherit', "}\n\n.bFgzf_bQpq{inset-inline-end:0;inset-inline-start:auto}\n\n[dir=ltr] .bFgzf_bQpq{left:auto;right:0}\n\n[dir=rtl] .bFgzf_bQpq{left:0;right:auto}\n\n.bFgzf_bQpq.bFgzf_dHtp{border-inline-start-width:").concat(theme.borderWidth || 'inherit', "}\n\n[dir=ltr] .bFgzf_bQpq.bFgzf_dHtp{border-left-width:").concat(theme.borderWidth || 'inherit', "}\n\n[dir=rtl] .bFgzf_bQpq.bFgzf_dHtp{border-right-width:").concat(theme.borderWidth || 'inherit', "}\n\n.bFgzf_dLYh{top:0}\n\n.bFgzf_dLYh.bFgzf_dHtp{border-bottom-width:").concat(theme.borderWidth || 'inherit', "}\n\n.bFgzf_bgun{bottom:0}\n\n.bFgzf_bgun.bFgzf_dHtp{border-top-width:").concat(theme.borderWidth || 'inherit', "}");
  },
  'root': 'bFgzf_bGBk',
  'border': 'bFgzf_dHtp',
  'shadow': 'bFgzf_fSpQ',
  'placement--bottom': 'bFgzf_bgun',
  'placement--top': 'bFgzf_dLYh',
  'placement--end': 'bFgzf_bQpq',
  'placement--start': 'bFgzf_bxia',
  'x-small': 'bFgzf_dfBC',
  'small': 'bFgzf_doqw',
  'regular': 'bFgzf_cXTs',
  'medium': 'bFgzf_ycrn',
  'large': 'bFgzf_cMDj',
  'placement--center': 'bFgzf_ehJX'
};

/**
---
category: components
---
**/
var Tray = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _deprecated.default)('3.0.0', {
  onRequestClose: 'onDismiss',
  isOpen: 'open',
  onReady: 'onOpen',
  onAfterOpen: 'onOpen',
  getDefaultFocusElement: 'defaultFocusElement',
  trapFocus: 'shouldContainFocus'
}), _dec3 = (0, _deprecated.default)('5.0.0', {
  closeButtonLabel: true,
  closeButtonRef: true,
  closeButtonVariant: true,
  applicationElement: true
}), _dec4 = (0, _bidirectional.default)(), _dec5 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tray, _Component);

  function Tray() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tray);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tray)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      transitioning: false
    };

    _this.handleTransitionComplete = function () {
      _this.setState({
        transitioning: false
      });
    };

    _this.handlePortalOpen = function (DOMNode) {
      _this.DOMNode = DOMNode; // We apply the theme here because now we have a DOM node (provided by Portal)

      DOMNode && _this.applyTheme(DOMNode);
    };

    _this.closeButtonRef = function (el) {
      _this._closeButton = el;

      if (typeof _this.props.closeButtonRef === 'function') {
        _this.props.closeButtonRef(el);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tray, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.setState({
          transitioning: true
        });
      }
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      return this.props.closeButtonLabel ? _react.default.createElement(_CloseButton.default, {
        placement: this.props.placement === 'end' ? 'start' : 'end',
        offset: "x-small",
        variant: this.props.closeButtonVariant,
        buttonRef: this.closeButtonRef,
        onClick: this.props.onDismiss
      }, this.props.closeButtonLabel) : null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return _react.default.createElement("div", null, this.renderCloseButton(), this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          label = _this$props.label,
          closeButtonLabel = _this$props.closeButtonLabel,
          children = _this$props.children,
          size = _this$props.size,
          placement = _this$props.placement,
          open = _this$props.open,
          defaultFocusElement = _this$props.defaultFocusElement,
          contentRef = _this$props.contentRef,
          closeButtonRef = _this$props.closeButtonRef,
          shouldContainFocus = _this$props.shouldContainFocus,
          shouldReturnFocus = _this$props.shouldReturnFocus,
          shouldCloseOnDocumentClick = _this$props.shouldCloseOnDocumentClick,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose,
          onDismiss = _this$props.onDismiss,
          mountNode = _this$props.mountNode,
          insertAt = _this$props.insertAt,
          liveRegion = _this$props.liveRegion,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onEntered = _this$props.onEntered,
          onExit = _this$props.onExit,
          onExiting = _this$props.onExiting,
          onExited = _this$props.onExited,
          onTransition = _this$props.onTransition,
          closeButtonVariant = _this$props.closeButtonVariant,
          border = _this$props.border,
          shadow = _this$props.shadow,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["label", "closeButtonLabel", "children", "size", "placement", "open", "defaultFocusElement", "contentRef", "closeButtonRef", "shouldContainFocus", "shouldReturnFocus", "shouldCloseOnDocumentClick", "onOpen", "onClose", "onDismiss", "mountNode", "insertAt", "liveRegion", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "onTransition", "closeButtonVariant", "border", "shadow"]);
      var portalIsOpen = open || this.state.transitioning;
      return _react.default.createElement(_Portal.default, {
        open: portalIsOpen,
        onOpen: this.handlePortalOpen,
        insertAt: insertAt,
        mountNode: mountNode
      }, portalIsOpen && _react.default.createElement(_Transition.default, {
        in: open,
        type: this.transition,
        onTransition: onTransition,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: (0, _createChainedFunction.default)(this.handleTransitionComplete, onEntered, onOpen),
        onExit: onExit,
        onExiting: onExiting,
        onExited: (0, _createChainedFunction.default)(this.handleTransitionComplete, onExited, onClose),
        transitionOnMount: true,
        transitionEnter: true,
        transitionExit: true
      }, _react.default.createElement("span", Object.assign({}, (0, _passthroughProps.omitProps)(props, Tray.propTypes), {
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles.border, border), (0, _defineProperty2.default)(_classnames, styles.shadow, shadow), (0, _defineProperty2.default)(_classnames, styles[size], true), (0, _defineProperty2.default)(_classnames, styles["placement--".concat(this.props.placement)], true), _classnames)),
        ref: contentRef
      }), this.state.transitioning ? this.renderContent() : _react.default.createElement(_Dialog.default, {
        as: "div",
        label: label,
        defaultFocusElement: this.defaultFocusElement,
        open: true,
        shouldContainFocus: shouldContainFocus,
        shouldReturnFocus: shouldReturnFocus,
        shouldCloseOnDocumentClick: shouldCloseOnDocumentClick,
        shouldCloseOnEscape: true,
        liveRegion: liveRegion,
        onDismiss: onDismiss
      }, this.renderContent()))));
    }
  }, {
    key: "placement",
    get: function get() {
      var placement = this.props.placement;
      return this.rtl ? (0, _mirrorPlacement.mirrorHorizontalPlacement)(placement, ' ') : placement;
    }
  }, {
    key: "direction",
    get: function get() {
      switch (this.placement) {
        case 'top':
          return 'up';

        case 'bottom':
          return 'down';

        case 'end':
          return 'right';

        default:
          // start
          return 'left';
      }
    }
  }, {
    key: "transition",
    get: function get() {
      return "slide-".concat(this.direction);
    }
  }, {
    key: "defaultFocusElement",
    get: function get() {
      var _this2 = this;

      return this.props.defaultFocusElement || function () {
        return _this2._closeButton;
      };
    }
  }, {
    key: "DOMNode",
    get: function get() {
      return this._DOMNode;
    },
    set: function set(el) {
      this._DOMNode = el;
    }
  }]);
  Tray.displayName = "Tray";
  return Tray;
}(_react.Component), _class2.propTypes = {
  label: _propTypes.default.string.isRequired,

  /**
   * __DEPRECATED (5.0.0)__ An accessible label for the close button. The close button won't display without this label.
   */
  closeButtonLabel: _propTypes.default.string,
  children: _propTypes.default.node,

  /*
   * The size (width) of the `<Tray />` when placement is `start` or `end`
   */
  size: _propTypes.default.oneOf(['x-small', 'small', 'regular', 'medium', 'large']),

  /**
  * Placement to determine where the `<Tray />` should display in the viewport
  */
  placement: _propTypes.default.oneOf(['top', 'bottom', 'start', 'end']),

  /**
   * Whether or not the `<Tray />` is open
   */
  open: _propTypes.default.bool,

  /**
   * An element or a function returning an element to focus by default
   */
  defaultFocusElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   *
   * A function that returns a reference to the content element
   */
  contentRef: _propTypes.default.func,

  /**
   * __DEPRECATED (5.0.0)__ A function that returns a reference to the close button element
   */
  closeButtonRef: _propTypes.default.func,

  /**
   * Whether focus should be contained within the `<Tray/>` when it is open
   */
  shouldContainFocus: _propTypes.default.bool,

  /**
   * Whether focus should be restored when the `<Tray/>` is closed
   */
  shouldReturnFocus: _propTypes.default.bool,

  /**
   * Should the `<Tray />` hide when clicks occur outside the content
   */
  shouldCloseOnDocumentClick: _propTypes.default.bool,

  /**
   * Callback fired when `<Tray />` content has been mounted in the DOM
   */
  onOpen: _propTypes.default.func,

  /**
   * Callback fired when `<Tray />` has been unmounted from the DOM
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the `<Tray />` is requesting to be closed
   */
  onDismiss: _propTypes.default.func,

  /**
   * An element or a function returning an element to use as the mount node
   * for the `<Tray />` (defaults to `document.body`)
   */
  mountNode: _propTypes.default.oneOfType([_uiPropTypes.element, _propTypes.default.func]),

  /**
   * Insert the element at the 'top' of the mountNode or at the 'bottom'
   */
  insertAt: _propTypes.default.oneOf(['bottom', 'top']),

  /**
   * An element, function returning an element, or array of elements that will not be hidden from
   * the screen reader when the `<Tray />` is open
   */
  liveRegion: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element, _propTypes.default.func]),

  /**
   * Callback fired when the <Tray /> transitions in/out
   */
  onTransition: _propTypes.default.func,

  /**
   * Callback fired before the <Tray /> transitions in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired as the <Tray /> begins to transition in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the <Tray /> finishes transitioning in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired right before the <Tray /> transitions out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired as the <Tray /> begins to transition out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the <Tray /> finishes transitioning out
   */
  onExited: _propTypes.default.func,

  /**
  * __DEPRECATED (5.0.0)__
  */
  closeButtonVariant: _propTypes.default.oneOf(['icon', 'icon-inverse']),

  /**
   * Should the `<Tray />` have a border
   */
  border: _propTypes.default.bool,

  /**
   * Should the `<Tray />` have a box shadow
   */
  shadow: _propTypes.default.bool
}, _class2.defaultProps = {
  open: false,
  onOpen: function onOpen(event) {},
  onClose: function onClose(event) {},
  onDismiss: function onDismiss(event) {},
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {},
  mountNode: null,
  insertAt: 'bottom',
  liveRegion: null,
  contentRef: function contentRef(el) {},
  shouldCloseOnDocumentClick: false,
  shouldContainFocus: true,
  shouldReturnFocus: true,
  defaultFocusElement: null,
  size: 'small',
  placement: 'start',
  shadow: true,
  border: false,
  children: null,
  closeButtonLabel: void 0,
  closeButtonRef: void 0,
  closeButtonVariant: void 0,
  onTransition: void 0
}, _temp)) || _class) || _class) || _class) || _class) || _class);
var _default = Tray;
exports.default = _default;